<template>
  <a-modal
    :maskClosable="false"
    width="50%"
    :loading="loading"
    :title="modalTitle"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-row>
        <a-col :span="12">
          <a-form-item label="用户姓名" v-bind="formItemLayout">
            <a-input
              v-decorator="['user_name',{rules: [{ required: true, message: '请输入用户姓名!' },{whitespace:true,message:'不允许输入空格！'},{ validator: checkName}] , initialValue: updateUserModel ? updateUserModel['user_name'] : ''}]"
              placeholder="请输入用户姓名"
            />
          </a-form-item>
          <a-form-item label="用户性别" v-show="!onlyAdmin" v-bind="formItemLayout">
            <a-select
              v-decorator="['user_sex',{ initialValue: onlyAdmin ? '0' : updateUserModel ? updateUserModel['user_sex'] : (sexTypeList && sexTypeList[0]) ? sexTypeList[0]['value'] : ''}]"
              placeholder="请选择用户性别"
            >
              <a-select-option
                :value="item.value"
                v-for="(item,idx) in sexTypeList"
                :key="idx"
              >{{item.label}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="用户邮箱" v-show="!onlyAdmin" v-bind="formItemLayout">
            <a-input
              v-decorator="['mailbox_no',{rules:[{type:'email',message:'请输入有效邮箱！'}] ,initialValue:updateUserModel ? updateUserModel['mailbox_no'] : ''}]"
              placeholder="请输入用户邮箱"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="用户账号" v-bind="formItemLayout">
            <a-input
              v-decorator="['user_code',{rules: [{ required: true, message: '请输入用户账号!' },{whitespace:true,message:'不允许输入空格！'},] , initialValue: updateUserModel ? updateUserModel['user_code'] : ''}]"
              placeholder="请输入用户账号"
            />
          </a-form-item>
          <a-form-item label="用户手机号" v-show="!onlyAdmin" v-bind="formItemLayout">
            <a-input
              v-decorator="['mobile_no',{rules:[{max:11, message:'手机号长度不超过11位！'},{validator: checkMobilePhone}],initialValue:updateUserModel ? updateUserModel['mobile_no'] : ''}]"
              placeholder="请输入用户手机号"
            />
          </a-form-item>
          <a-form-item label="用户类型" v-show="false" v-bind="formItemLayout">
            <a-select
              v-decorator="['user_type', {rules: [{ required: true, message: '请选择用户类型!' }],initialValue:onlyAdmin ? '0' : updateUserModel ? updateUserModel['user_type'] : (userTypeList && userTypeList[0]) ? userTypeList[0]['value'] : ''}]"
              placeholder="请选择用户类型"
            >
              <a-select-option
                :value="item.value"
                v-for="(item,idx) in userTypeList"
                :key="idx"
              >{{item.label}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import FormValid from "../libs/common/FormValid"
export default {
  name: "UserCUModal",
  props: ["updateUserModel", "title", "onlyAdmin", "orgId","systemId"],
  data() {
    return {
      visible: false,
      loading: false,
      form: this.$form.createForm(this),
      dic10003: {},
      dic10004: {},
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 }
      }
    };
  },
  created() {
    if (!this.onlyAdmin) {
      this.fetchDic();
    }
    this.visible = true;
    this.form.resetFields();
  },
  computed: {
    modalTitle() {
      return this.title
        ? this.title
        : this.updateUserModel
        ? "修改用户"
        : "新增用户";
    },
    userTypeList() {
      let userTypeList = [];
      if (this.dic10004) {
        for (const key in this.dic10004) {
          if (this.dic10004.hasOwnProperty(key)) {
            const element = this.dic10004[key];
            userTypeList.push({
              label: element,
              value: key
            });
          }
        }
      }
      return userTypeList;
    },
    sexTypeList() {
      let sexTypeList = [];
      if (this.dic10003) {
        for (const key in this.dic10003) {
          if (this.dic10003.hasOwnProperty(key)) {
            const element = this.dic10003[key];
            sexTypeList.push({
              label: element,
              value: key
            });
          }
        }
      }
      return sexTypeList;
    }
  },
  methods: {
    fetchDic() {
      const that = this;
      that.$http.post(
        that.$marco.api.getDictsForPage,
        {
          dicttypelist: ["10003", "10004"]
        },
        data => {
          that.dic10003 = data.dictlist[0]["10003"];
          that.dic10004 = data.dictlist[1]["10004"];
        },
        errorDesc => {
          Log.normal("字典查询:" + JSON.stringify(errorDesc));
        },
        error => {
          Log.error("字典查询:" + JSON.stringify(error));
        },
        that
      );
    },
    handleOk() {
      const that = this;
      this.form.validateFields((err, values) => {
        if (err) return;
        let url = that.$marco.api.userAdded;
        if (this.updateUserModel) {
          values["user_id"] = that.updateUserModel["user_id"];
          url = that.$marco.api.userUpdate;
        }
        if (this.orgId) {
          values["org_id"] = that.orgId;
        }
        if(this.systemId){
          values["system_id"] = that.systemId;
        }
        that.submitForm(url, values);
      });
    },
    handleCancel() {
      this.visible = false;
      this.$emit("close");
    },
    submitForm(url, values) {
      const that = this;
      that.loading = true;
      that.$http.post(
        url,
        values,
        data => {
          that.loading = false;
          that.$message.success(that.updateUserModel ? "修改成功" : "添加成功");
          that.$emit("close", true);
        },
        errorDesc => {
          that.loading = false;
          that.$log.normal(JSON.stringify(errorDesc));
          that.$message.error(errorDesc);
        },
        error => {
          that.loading = false;
          that.$log.error(JSON.stringify(error));
          that.$message.error(error);
        },
        that
      );
    },
    checkName(rule,value,callback){
      !FormValid.checkName(value) && (value.length != 0)
        ? callback(new Error("请输入合法名称！"))
        : callback();
    },
    checkMobilePhone(rule,value,callback){
      !FormValid.checkMobilePhone(value) && (value.length != 0)
        ? callback(new Error("请输入正确的手机号码！"))
        : callback();
    }
  }
};
</script>
<style>
</style>
